/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import SubmitButton from '../../components/buttons/SubmitButton/';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { createSelector } from 'reselect';
// import { ProjectActions } from '../actions/project';
// import { ModalActions } from '../../actions/modal';
import { ElementTypeActions } from '../../actions/elementType';
import { validateAndDispatch } from '../../helpers/form';
import InputField from '../form/InputField';

// @connect(state => ({
//   form: state.createElementTypeForm.get('form'),
//   notifications: state.createElementTypeForm.get('notifications'),
//   submitting: state.createProjectForm.get('submitting'),
//   elementTypes: state.elementTypes.get('elementTypes'),
//   router: state.router,
//   projectId: state.projects.get('currentProjectId')
// }))
// @connect(CreateElementModalSelector)

const currentProjectIdSelector = (state) => {
  const projectId = state.projects.get('currentProjectId');
  return projectId || null;
};

const createElementTypeModalSelector = (state) => {
  const selector = formValueSelector('createElementType');
  return selector(state, 'type');
};

const CreateElementTypeModalSelector = createSelector(
  [currentProjectIdSelector, createElementTypeModalSelector],
  (currentProjectId, createElementTypeModal) => ({
    currentProjectId,
    fields: createElementTypeModal,
    initialValues: {
      type: null,
    },
  })
);

@connect(CreateElementTypeModalSelector)
@reduxForm({
  form: 'createElementType',
  destroyOnUnmount: true,
  enableReinitialize: false,
})
export default class CreateElementTypeModal extends Component {
  static propTypes = {
    currentProjectId: PropTypes.string,
    createElementTypeForm: PropTypes.object,
    handleSubmit: PropTypes.func,
    reset: PropTypes.func,
    dispatch: PropTypes.func,
  }

  submit = (values, dispatch) => {
    const {
      currentProjectId,
      reset
    } = this.props;

    const elementType = {
      type: values.type,
      project_id: currentProjectId,
    };

    const validation = {
      type: [{ rule: 'required', label: 'element type name' }]
    };

    console.log('name', values.type);
    return validateAndDispatch(dispatch,
      ElementTypeActions.createElementType(elementType), validation, values
    ).then(() => {
      reset();
    });
  }

  render() {
    const {
      handleSubmit,
      submitting,
    } = this.props;

    const elementTypeNameField = (
      <fieldset className="form-group">
        <Field
          name="type"
          type="input"
          component={InputField}
          label="Element Type Name"
          className="form-control"
          wrapperClassName="form-group row"
          labelClassName="col-sm-2 col-form-label"
          containerClassName="col-sm-10"
          placeholder="Element Type Name"
          style={{ marginBottom: 10 }}
          autoFocus
        />
      </fieldset>);

    return (
      <div className="fs-modal-content">
        <h4>Create Element Type</h4>
        <form>
          <div className="modal-form-wrapper">
            {elementTypeNameField}
          </div>
          <div className="modal-form-button-wrapper">
            <SubmitButton
              className="modal-submit-btn"
              submitting={submitting}
              onClick={handleSubmit(this.submit)}
            >
              Create
            </SubmitButton>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/CreateElementTypeModal.js